import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../mock";

const FAQ = () => {
  return (
    <section className="py-20 md:py-28 px-5 md:px-8 bg-[#E7EDF3]">
      <div className="max-w-3xl mx-auto">
        <div className="text-center fade-up">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-px w-6 bg-[#159A90]" />
            <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
              FAQs
            </span>
            <span className="h-px w-6 bg-[#159A90]" />
          </div>
          <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[32px] md:text-[42px] leading-tight">
            Everything you'd want to know before booking
          </h2>
          <p className="text-[#57616e] mt-4 text-[16px]">
            Still have questions? Our care team is on standby 24/7 to walk you
            through the process.
          </p>
          <a
            href="#book"
            className="inline-block mt-6 px-7 py-3 rounded-full bg-[#159A90] text-white font-semibold hover:bg-[#0E7A72] transition-colors shadow-[0_10px_30px_rgba(21,154,144,0.35)]"
          >
            Talk to a Care Manager
          </a>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-[#DEE6EE] px-6 shadow-[0_4px_16px_rgba(0,0,0,0.03)]"
            >
              <AccordionTrigger className="font-heading font-semibold text-[16px] text-[#1B2A4A] hover:no-underline text-left py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent forceMount className="text-[14.5px] text-[#6b7481] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
